import { FC, useCallback } from 'react';
import { GridRenderEditCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import { orderDetailsState as orderDetailsStateEdit } from '../../../../edit/states/orderDetails/orderDetails.state.ts';
import { TableNumericField } from '../../../../../../shared/components/table/styles/styleFields.ts';
import { clearRowFromVirtualKeys } from '../splitting/additionalFunctions.tsx';
import { blockArrowKeysInMiddle } from '../../../../../../shared/components/table/functions/sharedFunc.ts';

export const CorrectionValueEditCell: FC<GridRenderEditCellParams> = ({ api, ...params }) => {
  const { setEditCellValue } = api;
  const { value, field, id, formattedValue, row } = params;

  const updateCell = useCallback(
    (v: number | null) => {
      setEditCellValue({ id, field, value: v });
      if (Number(formattedValue) !== v) {
        const clearedRow = clearRowFromVirtualKeys(row);
        orderDetailsStateEdit.pub.updateCell(
          { ...clearedRow, correctionValue: v },
          'correctionValueCell',
        );
      }
    },
    [setEditCellValue, id, field, formattedValue, row],
  );

  return (
    <TableNumericField
      slotProps={{ htmlInput: { autoComplete: 'off' } }}
      onBlur={updateCell}
      min={-10000000}
      autoFocus
      precision={3}
      noTrailingZeros
      value={value}
      onKeyDown={blockArrowKeysInMiddle}
      keyChange={false}
    />
  );
};
